import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserService } from 'app/core/user/user.service';
import { environment } from 'environments/environment';
import { catchError, Observable, of, Subject, switchMap, takeUntil, throwError } from 'rxjs';
import { AuthService } from '@auth0/auth0-angular';
import { AuthUtils } from './auth.utils';

@Injectable({providedIn: 'root'})
export class LocalAuthService
{
    private _authenticated: boolean = false;

    /**
     * Constructor
     */
    constructor(
        private _httpClient: HttpClient,
        private _userService: UserService,
        private _authService: AuthService,
    )
    {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Setter & getter for access token
     */
    set accessToken(token: string)
    {
        localStorage.setItem('accessToken', token);
    }

    get accessToken(): string
    {
        return localStorage.getItem('accessToken') ?? '';
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Sign in
     *
     * @param credentials
     */
    signIn(parameter): Observable<any>
    {
        return this._httpClient.post(`${environment.oDataUrl}/api/Authenticate/LoginAuth0`, parameter).pipe(
            switchMap((response: any) =>
            {
                // Store the access token in the local storage
                this.accessToken = response.swimAccessToken.accessToken;

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response;
                
                // Return a new observable with the response
                return of(response);
            }),
        );
    }

    /**
     * Sign in using the access token
     */
    signInUsingToken(): Observable<any>
    {
        // Sign in using the token
        return this._httpClient.post('api/auth/sign-in-with-token', {
            accessToken: this.accessToken,
        }).pipe(
            catchError(() =>

                // Return false
                of(false),
            ),
            switchMap((response: any) =>
            {
                // Replace the access token with the new one if it's available on
                // the response object.
                //
                // This is an added optional step for better security. Once you sign
                // in using the token, you should generate a new one on the server
                // side and attach it to the response object. Then the following
                // piece of code can replace the token with the refreshed one.
                if ( response.accessToken )
                {
                    this.accessToken = response.accessToken;
                }

                // Set the authenticated flag to true
                this._authenticated = true;

                // Store the user on the user service
                this._userService.user = response.user;

                // Return true
                return of(true);
            }),
        );
    }

    /**
     * Sign out
     */
    signOut(): Observable<any>
    {
        //Auth0 logout implementation
        this._authService.isAuthenticated$.pipe().subscribe(val => {
            if(val) {
                this._authService.logout({ logoutParams: { returnTo: document.location.origin } });
                // Remove the access token from the local storage
                localStorage.removeItem('accessToken');
                // Set the authenticated flag to false
                this._authenticated = false;
            }
        });

        // Return the observable
        return of(true);
    }

    signOutDirect(): void
    {
        // Remove local token
        localStorage.removeItem('accessToken');

        // Update state
        this._authenticated = false;

        // Auth0 logout
        this._authService.logout({
            logoutParams: {
                returnTo: window.location.origin
            }
        });
    }


    /**
     * Check the authentication status
     */
    check(): Observable<boolean>
    {
         // Check the access token availability
        if ( !this.accessToken )
        {
            return of(false);
        }
          // Check the access token expire date
        if ( AuthUtils.isTokenExpired(this.accessToken) )
        {
            return of(false);
        }
        // Check if the user is logged in
        if ( this._authenticated )
        {
            return of(true);
        }

       

      

        // If the access token exists, and it didn't expire, sign in using it
        //return this.signInUsingToken();
        return of(false);
    }
}
